export const AMORTISMAN_UYGULANMAZ_VALUE = "uygulanmaz";

export const AMORTISMAN_STATUS_LABELS = {
	belirlenmedi: "Belirlenmedi",
	uygulanmaz: "Uygulanmaz",
	takip_arsivli: "Takip Ar\u015fivli",
	devam_ediyor: "Devam Ediyor",
	yaklasiyor: "Yakla\u015f\u0131yor",
	faydali_omru_doldu: "Faydal\u0131 \u00d6mr\u00fc Doldu",
	inceleme_bekliyor: "\u0130nceleme Bekliyor",
	// Eski snapshot ve export kayitlari icin geriye donuk label.
	suresi_doldu: "S\u00fcresi Doldu",
};

export async function fetchAmortismanDefinitions({ includeInactive = false } = {}) {
	const suffix = includeInactive ? "?include_inactive=1" : "";
	const response = await fetch(`/api/amortisman-tanimlari${suffix}`);
	const data = await response.json().catch(() => ({}));
	if (!response.ok) throw new Error(data?.error || "Faydal\u0131 \u00f6m\u00fcr tan\u0131mlar\u0131 al\u0131namad\u0131.");
	return data.items || [];
}

export function populateAmortismanSelect(selectEl, definitions, options = {}) {
	if (!selectEl) return;
	const selectedDefinitionId = options.selectedDefinitionId == null
		? ""
		: String(options.selectedDefinitionId);
	const selectedValue = options.uygulanmaz
		? AMORTISMAN_UYGULANMAZ_VALUE
		: selectedDefinitionId;
	selectEl.innerHTML = "";

	const placeholder = document.createElement("option");
	placeholder.value = "";
	placeholder.textContent = options.allowUnclassified
		? "Belirlenmedi"
		: "Faydal\u0131 \u00f6m\u00fcr se\u00e7iniz";
	selectEl.appendChild(placeholder);

	const items = [...(definitions || [])];
	if (selectedDefinitionId && !items.some((item) => String(item.id) === selectedDefinitionId) && options.currentDefinition) {
		items.push(options.currentDefinition);
	}
	items.forEach((item) => {
		const option = document.createElement("option");
		option.value = String(item.id);
		option.textContent = `${item.name} - ${item.faydali_omur_yil} y\u0131l${item.is_active === false ? " (Pasif)" : ""}`;
		option.dataset.years = String(item.faydali_omur_yil);
		selectEl.appendChild(option);
	});

	const notApplicable = document.createElement("option");
	notApplicable.value = AMORTISMAN_UYGULANMAZ_VALUE;
	notApplicable.textContent = "Amortisman uygulanmaz";
	selectEl.appendChild(notApplicable);

	selectEl.value = selectedValue;
	selectEl.required = !options.allowUnclassified;
}

export function readAmortismanSelection(selectEl) {
	const value = String(selectEl?.value ?? "");
	if (value === AMORTISMAN_UYGULANMAZ_VALUE) {
		return { amortisman_tanim_id: null, amortisman_uygulanmaz: true };
	}
	return {
		amortisman_tanim_id: /^\d+$/.test(value) ? Number(value) : null,
		amortisman_uygulanmaz: false,
	};
}

export function addYearsDateOnly(dateValue, yearsValue) {
	const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(dateValue || ""));
	const years = Number(yearsValue);
	if (!match || !Number.isInteger(years) || years < 1) return "";

	const sourceYear = Number(match[1]);
	const month = Number(match[2]);
	const day = Number(match[3]);
	const targetYear = sourceYear + years;
	const lastDay = new Date(Date.UTC(targetYear, month, 0)).getUTCDate();
	return `${targetYear}-${String(month).padStart(2, "0")}-${String(Math.min(day, lastDay)).padStart(2, "0")}`;
}

export function formatDateOnlyTr(dateValue) {
	const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(dateValue || ""));
	return match ? `${match[3]}.${match[2]}.${match[1]}` : "\u2014";
}

export function updateAmortismanPreview(cardEl) {
	const selectEl = cardEl?.querySelector('[data-fatura-field="amortisman"], [data-edit-fatura-field="amortisman"]');
	const dateEl = cardEl?.querySelector('[data-fatura-field="satin_alma_tarih"], [data-edit-fatura-field="satin_alma_tarih"]');
	const yearsOut = cardEl?.querySelector(".fatura-amortisman-yil");
	const endOut = cardEl?.querySelector(".fatura-amortisman-bitis");
	if (!selectEl || !yearsOut || !endOut) return;

	if (selectEl.value === AMORTISMAN_UYGULANMAZ_VALUE) {
		yearsOut.textContent = "Uygulanmaz";
		endOut.textContent = "\u2014";
		return;
	}
	const option = selectEl.options[selectEl.selectedIndex];
	const years = Number(option?.dataset?.years);
	if (!selectEl.value || !Number.isInteger(years)) {
		yearsOut.textContent = "\u2014";
		endOut.textContent = "\u2014";
		return;
	}
	yearsOut.textContent = `${years} y\u0131l`;
	endOut.textContent = formatDateOnlyTr(addYearsDateOnly(dateEl?.value, years));
}
